export default __webpack_public_path__ + "static/media/chuseok53.51d0c043.jpg";